const LANDING = '/';
const SIGN_UP = '/signup';
const SIGN_IN = '/signin';
const HOME = '/app';
const FORGET_PASSWORD = '/forget-password';
const VERIFY_EMAIL = '/verify-email';
const SIGN_OUT = 'signout';
const CAMPAIGN_DETAIL = '/campaign';
const MY_DASHBOARD = '/my-dashboard';
const MY_FLOWERS = 'my-designs';
const CREATORS = 'creators';
const LIVE_STREAMERS = 'live-streamers';
const TERMS_CONDITIONS = 'tos';
const PRIVACY = 'privacy';
const COOKIE = 'cookie';
const REFUND = '/refund';
const DELIVERY = '/delivery';
const CONTACT = '/contact';
const ACCEPTABLE_USE = '/acceptable-use';
const APP = '/app';
const AGENCIES= '/agencies'
const X = '/x'
const LINKEDIN = '/linkedin'
const YEARBOOK = '/how-to-get-ai-yearbook-for-free'
const AIHEADSHOT_GENERATOR = '/ai-headshot-generator'
const AIINFLUENCERS = '/ai-influencers'
const AISHORTS = '/ai-shorts'
const AIHEADSHOT = '/free-trial'
const LEGAL = '/legal'
const DATING_PHOTOS = '/dating-photos'
const STUDENT_HEADSHOTS = '/student-headshots'
const BUSINESS_HEADSHOTS = '/businesses-headshots'
const HEADSHOTS_FOR_COMPANY = 'headshots-for-company'
const SEO_LINKEDIN = '/ai-headshots-linkedin'
const SEO_REALTORS = '/ai-headshots-realtors'
const SEO_EXECUTIVES = '/ai-headshots-executives'
const SEO_TEAMS = '/ai-headshots-teams'
const SEO_JOB_SEEKERS = '/ai-headshots-job-seekers'
const SEO_UPLOAD_GUIDE = '/ai-headshot-upload-guide'
const SEO_PRIVACY_DELETION = '/ai-headshot-privacy-data-deletion'
const BLOG = '/blog'
const BLOG_POST = '/blog/:slug'
const ADMIN = '/admin'
const BILLING = '/app/billing'
const SETTINGS = '/app/settings'

export { 
    LANDING, 
    SIGN_UP,
    SIGN_IN, 
    APP, 
    HOME, 
    SIGN_OUT,
    VERIFY_EMAIL,
    LEGAL,
    REFUND,
    DELIVERY,
    CONTACT,
    ACCEPTABLE_USE,
    DATING_PHOTOS,
    STUDENT_HEADSHOTS, 
    BUSINESS_HEADSHOTS, 
    X, 
    LINKEDIN, 
    YEARBOOK, 
    AIHEADSHOT,
    AIHEADSHOT_GENERATOR,
    AIINFLUENCERS,
    AISHORTS,
    HEADSHOTS_FOR_COMPANY,
    SEO_LINKEDIN,
    SEO_REALTORS,
    SEO_EXECUTIVES,
    SEO_TEAMS,
    SEO_JOB_SEEKERS,
    SEO_UPLOAD_GUIDE,
    SEO_PRIVACY_DELETION,
    BLOG,
    BLOG_POST,
    ADMIN,
    BILLING,
    SETTINGS
};
